"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _masthead = _interopRequireDefault(require("@amzn/meridian-tokens/component/masthead"));

var _mastheadLink = _interopRequireDefault(require("./masthead-link"));

var _mastheadTitle = _interopRequireDefault(require("./masthead-title"));

var _mastheadMenuButton = _interopRequireDefault(require("./masthead-menu-button"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));

var _isElementOfAny = _interopRequireDefault(require("./../_utils/is-element-of-any"));

var _text = _interopRequireDefault(require("./../_styles/text"));

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _mdnMastheadAc;

  var size = _ref.size,
      backgroundColor = _ref.backgroundColor;
  return (0, _emotion.css)((0, _text["default"])(t), {
    display: "flex",
    alignItems: "stretch",
    boxShadow: t.boxShadowCss("shadow"),
    backgroundColor: backgroundColor ? (0, _token.getToken)(t.tokens, "themeBackground", [backgroundColor, "default"]) || backgroundColor : t("backgroundColor"),
    borderBottom: t.borderCss("border"),
    // Allow the masthead to be horizontally scrolled on zoomed-in screens
    overflow: "auto",
    minHeight: t("size", size),
    // Don't allow a flex parent to squish us
    flexShrink: 0,
    // This ensures that the masthead shadow is visible over elements below
    // it in webkit.
    position: "relative",
    zIndex: t("elevation"),
    // Title (and menu)
    "& > [mdn-masthead-title]": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: size === "small" ? 0 : "8px 0"
    },
    // Links
    "& > [mdn-masthead-links]": (0, _defineProperty2["default"])({
      display: "flex",
      alignItems: "stretch",
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   marginInlineStart: t("spacingHorizontal"),
      // }
      marginLeft: t("spacingHorizontal")
    }, "[dir=\"rtl\"] &", {
      marginRight: t("spacingHorizontal"),
      marginLeft: 0
    }),
    // Actions
    "& > [mdn-masthead-actions]": (_mdnMastheadAc = {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "".concat(size === "small" ? "0px" : "8px", " ").concat(t("spacingHorizontal"), "px"),
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   marginInlineStart: "auto",
      // }
      marginLeft: "auto"
    }, (0, _defineProperty2["default"])(_mdnMastheadAc, "[dir=\"rtl\"] &", {
      marginRight: "auto",
      marginLeft: 0
    }), (0, _defineProperty2["default"])(_mdnMastheadAc, "& > * + *", (0, _defineProperty2["default"])({
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   marginInlineStart: "8px !important",
      // }
      marginLeft: "8px !important"
    }, "[dir=\"rtl\"] &", {
      marginRight: "8px !important",
      marginLeft: "0 !important"
    })), _mdnMastheadAc),
    // HACK: IE11 doesn't respect min-height on a flex container, so we also
    // have to set the min height on all the children. See:
    // https://stackoverflow.com/a/40775383
    "& > *": {
      boxSizing: "border-box",
      minHeight: t("size", size)
    }
  });
}, ["size", "backgroundColor"]);
/**
 * This component can be used to render a top navigation bar for your
 * application.
 */

var Masthead = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Masthead, _React$Component);

  var _super = _createSuper(Masthead);

  function Masthead() {
    var _this;

    (0, _classCallCheck2["default"])(this, Masthead);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMenuButton", (0, _isElementOf["default"])(_this.props.menuButtonComponent));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isTitle", (0, _isElementOf["default"])(_this.props.titleComponent));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isLink", (0, _isElementOfAny["default"])(_this.props.linkComponents));
    return _this;
  }

  (0, _createClass2["default"])(Masthead, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          size = _this$props.size,
          backgroundColor = _this$props.backgroundColor;

      var children = _react["default"].Children.toArray(this.props.children);

      var menuButton = children.filter(this.isMenuButton)[0];
      var title = children.filter(this.isTitle)[0];
      var links = children.filter(this.isLink).map(function (link) {
        return /*#__PURE__*/_react["default"].cloneElement(link, {
          size: size
        });
      });
      var actions = children.filter(function (child) {
        return !_this2.isMenuButton(child) && !_this2.isTitle(child) && !_this2.isLink(child);
      });
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _masthead["default"],
        map: (0, _token.getTokenHelper)("masthead")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("nav", (0, _extends2["default"])({
          className: styles(t, {
            size: size,
            backgroundColor: backgroundColor
          })
        }, passThroughProps), menuButton || title ? /*#__PURE__*/_react["default"].createElement("div", {
          "mdn-masthead-title": ""
        }, menuButton, title) : null, links.length ? /*#__PURE__*/_react["default"].createElement("div", {
          "mdn-masthead-links": ""
        }, links) : null, actions.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
          "mdn-masthead-actions": ""
        }, actions) : null);
      });
    }
  }]);
  return Masthead;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Masthead, "defaultProps", {
  size: "medium",
  menuButtonComponent: _mastheadMenuButton["default"],
  titleComponent: _mastheadTitle["default"],
  linkComponents: [_mastheadLink["default"]]
});
Masthead.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the masthead.
   *
   * If any `MastheadTitle`, `MastheadLink`, or `MastheadMenuButton`
   * components are included as children they will be automatically positioned
   * n the correct locations. All other children (e.g. action buttons) will be
   * aligned with the right edge of the masthead.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the masthead's background color using a preset, or using a string
   * containing any valid CSS color.
   *
   * @since 5.18.0
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The component or components that will render each Masthead link. Defaults
   * to `MastheadLink`. If a higher-order component that wraps a MastheadLink
   * component is specified here, it must accept a "size" props and pass that
   * down to the MastheadLink component.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  linkComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * The component that will render the menu button. Defaults to
   * `MastheadMenuButton`.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  menuButtonComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * Sets the height of the masthead using a preset. Use this to adapt
   * the masthead to various screen sizes.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large"]),

  /**
   * The component that will render the title (or logo). Defaults to
   * `MastheadTitle`.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  titleComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
} : {};
var _default = Masthead;
exports["default"] = _default;